module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-7-c72cbc1612e3802e3810a1dae1a501f1.png";